import { lazy } from "react";

const ChecklistOru = lazy(() =>
      import("../../operacion/checklistOru.jsx")
);

const ConsumosLayout = lazy(() =>
      import("../../consumos/ConsumosLayout.jsx")
);

const Consumos = lazy(() =>
      import("../../consumos/Consumos.jsx")
);

const operacionRoutes = [
      {
            path: "checklist",
            element: <ChecklistOru />,
      },
      {
            path: "consumos",
            element: <ConsumosLayout />,
            children: [
                  { index: true, element: <Consumos /> },
            ],
      },
];

export default operacionRoutes;